import { render, staticRenderFns } from "./talents_details.vue?vue&type=template&id=b600eb30&scoped=true"
import script from "./talents_details.vue?vue&type=script&lang=js"
export * from "./talents_details.vue?vue&type=script&lang=js"
import style0 from "./talents_details.vue?vue&type=style&index=0&id=b600eb30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b600eb30",
  null
  
)

export default component.exports